import { Fragment } from "react";
import { ListGroup } from "reactstrap";
import { UnorderedListProps } from "../../Types/CommonElementType";

const UL: React.FC<UnorderedListProps> = (props) => {
  return (
    <Fragment>
      <ListGroup {...props}>{props.children}</ListGroup>
    </Fragment>
  );
};

export default UL;
